import React, { FunctionComponent, ReactNode, useState } from 'react'

interface Props {
  href: string
  styleId: string
  title: string
  description: string
  documents: Array<ReactNode>
  initialOpenState?: boolean
}

const DocumentCategory: FunctionComponent<Props> = props => {
  const [isOpened, setIsOpened] = useState(props.initialOpenState ?? true)

  const onClick = () => setIsOpened(!isOpened)

  return (
    <div className='list grid collapsable' data-type='resources'>
      <header>
        <a href={props.href} data-toggle='collapsable' className={isOpened ? 'open' : ''} onClick={onClick}>
          <h3>{props.title}</h3>
          <p>{props.description}</p>
        </a>
      </header>

      <ul id={props.styleId} className={isOpened ? 'collapsable-content' : 'collapsable-content hidden'}>
        {props.documents}
      </ul>
    </div>
  )
}

export default DocumentCategory
